// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/Assets/Feeds/backgroundImg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SingleVote{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100%;
  height: 100%;
  background-color: #071414;
  overflow-y: hidden;
}`, "",{"version":3,"sources":["webpack://./src/Components/SingleVote/SingleVote.css"],"names":[],"mappings":"AAAA;IACI,yDAAuE;EACzE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".SingleVote{\n    background-image: url(\"../../../public/Assets/Feeds/backgroundImg.svg\");\n  width: 100%;\n  height: 100%;\n  background-color: #071414;\n  overflow-y: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
